var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.catChildren.length > 0 && !_vm.isFiltered
    ? _c("div", { staticClass: "category-navigation__wrapper" }, [
        _c("div", { staticClass: "container-max" }, [
          _c(
            "div",
            {
              ref: "topRow",
              staticClass: "row justify-content-center top-row",
              class: { open: _vm.showMore },
              style: "height:" + _vm.topRowHeight + "px",
            },
            _vm._l(
              _vm.showMore || _vm.closeCats.length < 4
                ? _vm.catChildren
                : _vm.closeCats,
              function (child, key) {
                return key < (_vm.isMobile ? 3 : 4) && !_vm.showAllItems
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "category-navigation__item col-12 col-md-4 col-lg-3",
                        attrs: {
                          href:
                            _vm.mainCat +
                            "/" +
                            child.category.details[0].nameUrl,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "category-navigation__img-wrapper" },
                          [
                            _c("img", {
                              staticClass: "category-navigation__img",
                              attrs: {
                                src:
                                  child.image !== ""
                                    ? child.image
                                    : "/documents/" +
                                      child.category.details[0].imagePath,
                                alt: child.category.details[0].name,
                                title: child.category.details[0].name,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "category-navigation__content" },
                          [
                            _c(
                              "div",
                              { staticClass: "category-navigation__name" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(child.category.details[0].name) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "category-navigation__desc" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      child.category.details[0].shortDescription
                                    ) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e()
              }
            ),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row justify-content-center collapse",
              class: { show: _vm.showAllItems },
              attrs: { id: "collapseExample" },
            },
            _vm._l(_vm.catChildren, function (child, key) {
              return _c(
                "a",
                {
                  staticClass:
                    "category-navigation__item col-12 col-md-4 col-lg-3",
                  attrs: {
                    href: _vm.mainCat + "/" + child.category.details[0].nameUrl,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "category-navigation__img-wrapper" },
                    [
                      _c("img", {
                        staticClass: "category-navigation__img",
                        attrs: {
                          src:
                            child.image !== ""
                              ? child.image
                              : "/documents/" +
                                child.category.details[0].imagePath,
                          alt: child.category.details[0].name,
                          title: child.category.details[0].name,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "category-navigation__content" }, [
                    _c("div", { staticClass: "category-navigation__name" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(child.category.details[0].name) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "category-navigation__desc" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(child.category.details[0].shortDescription) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.catChildren.length > 4 && _vm.showAllItems === false
            ? _c(
                "div",
                { staticClass: "col-12 category-navigation__button-wrapper" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "category-navigation__button",
                      class: { active: _vm.showMore === true },
                      attrs: {
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapseExample",
                        "aria-expanded": "false",
                        "aria-controls": "collapseExample",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showMore = !_vm.showMore
                        },
                      },
                    },
                    [
                      _vm.showMore === false
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "HoferAntikschmuck::Template.all"
                                )
                              ) +
                                " " +
                                _vm._s(_vm.mainCatName)
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showMore === true
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "HoferAntikschmuck::Template.showLess"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "mobile-nav__chevron",
                          attrs: { fill: "currentColor" },
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#chevron-down" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        !_vm.showAllItems
          ? _c("div", { staticClass: "hofer-hr__wrapper" }, [
              _c("div", { staticClass: "hofer-hr" }, [
                _c(
                  "svg",
                  {
                    staticClass: "mobile-nav__chevron",
                    attrs: { fill: "currentColor" },
                  },
                  [_c("use", { attrs: { "xlink:href": "#logo-minimal" } })]
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }